import { IconProps } from './types';

export const AudioIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 33.455 43.477'>
    <path
      // eslint-disable-next-line max-len
      d='M39.181,3.4c-.491.094-21.112,4.1-21.551,4.181a.927.927,0,0,0-.847.836V33.506a2.883,2.883,0,0,1-.251,1.223,2.785,2.785,0,0,1-1.683,1.327c-.345.115-.815.219-1.369.345-2.519.564-6.731,1.526-6.731,5.414a4.784,4.784,0,0,0,4.358,4.964,5.1,5.1,0,0,0,.742.073h0a12.9,12.9,0,0,0,5.351-1.38,5.631,5.631,0,0,0,2.519-5V18.268a.829.829,0,0,1,.669-.815l15.886-3.209a.836.836,0,0,1,1,.815V28.74a3,3,0,0,1-.261,1.4,2.778,2.778,0,0,1-1.693,1.327c-.345.115-.92.219-1.474.345-2.519.564-6.731,1.515-6.731,5.4a4.793,4.793,0,0,0,4.369,5.048,8.637,8.637,0,0,0,2.028-.094,11.982,11.982,0,0,0,3.815-1.359A5.509,5.509,0,0,0,40.2,35.774V4.2A.828.828,0,0,0,39.181,3.4Z'
      transform='translate(-6.75 -3.375)'
      {...props}
    />
  </svg>
);
